import moment from 'moment';

export const getTomorrowDateByDay = () => moment().add(1, 'days');
